import { Stack } from '@factorialco/f0-react/dist/experimental'
import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import EffectiveOnField from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/BasicInformation/EffectiveOnField'
import OwnerField from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/BasicInformation/OwnerField'
import Category from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Category'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {
  onEmployeeIdChange: (employeeId: number | undefined) => void
  isAutomaticExpensable: boolean
  hasReportOnBehalfFeature: boolean
  canCreateExpensesForOthers: boolean
  canSeeEmployeeLegalEntity: boolean
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
  onEffectiveOnChange: (value: string) => void
}

const ExpenseInformation = (props: Props) => {
  const {
    canSeeEmployeeLegalEntity,
    isAutomaticExpensable,
    currentEmployee,
    onEmployeeIdChange,
    hasReportOnBehalfFeature,
    canCreateExpensesForOthers,
    resourceType
  } = props

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.expense_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.expense_information_subtitle')}
    >
      <Stack gap="6">
        <OwnerField
          {...props}
          currentEmployee={currentEmployee}
          showEmployeeLegalEntity={canSeeEmployeeLegalEntity}
          isAutomaticExpensable={isAutomaticExpensable}
          onEmployeeIdChange={onEmployeeIdChange}
          hasReportOnBehalfFeature={hasReportOnBehalfFeature}
          canCreateExpensesForOthers={canCreateExpensesForOthers}
        />
        <Category {...props} />
        <EffectiveOnField {...props} fieldIdentifier="effective_on" resourceType={resourceType} />
      </Stack>
    </FormBlock>
  )
}

export default ExpenseInformation
